import React from 'react';  
import { motion } from 'framer-motion';  
import { ArrowRight, MapPin, Building } from 'lucide-react';  
import { Link } from 'react-router-dom';  

const PropertyCard = ({ propiedad }) => {  
  return (  
    <motion.div  
      className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 group"  
      initial={{ opacity: 0, y: 20 }}  
      whileInView={{ opacity: 1, y: 0 }}  
      transition={{ duration: 0.5 }}  
      whileHover={{ y: -5 }}  
    >  
      <div className="relative h-48 bg-gradient-to-br from-blue-50 to-purple-50 overflow-hidden">  
        <img  
          src={propiedad.imagen}  
          alt={propiedad.nombre}  
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"  
        />  
        <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-semibold text-gray-700">  
          {propiedad.tipo}  
        </div>  
      </div>  
      <div className="p-6">  
        <h3 className="text-xl font-bold text-gray-900 mb-2">{propiedad.nombre}</h3>  
        <p className="text-gray-600 mb-3 line-clamp-2">{propiedad.descripcion_corta}</p>  
        <div className="flex items-center justify-between">  
          <div className="flex items-center gap-2 text-gray-500">  
            <MapPin className="w-4 h-4" />  
            <span className="text-sm">{propiedad.ubicacion}</span>  
          </div>  
          <Link  
            to={`/propiedad/${propiedad.id}`}  
            className="flex items-center gap-2 text-blue-600 hover:text-blue-800 font-medium transition-colors"  
          >  
            Ver detalles  
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />  
          </Link>  
        </div>  
      </div>  
    </motion.div>  
  );  
};  

export default PropertyCard;